import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = ["src"];
import { getStore } from '@/util/store';
import { watch, ref } from 'vue';
export default {
  __name: 'iframePage',
  props: {
    alias: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var url = ref('');

    // 构造url
    var buildUrl = function buildUrl(alias) {
      var _window;
      var _ref = ((_window = window) === null || _window === void 0 || (_window = _window.$wujie) === null || _window === void 0 ? void 0 : _window.props.accessInfo) || getStore({
          name: 'accessInfo'
        }) || {},
        access_token = _ref.access_token;
      if (!access_token) {
        throw new Error('请检查项目是否运行在无界环境，或者确认浏览器本地存储中accessInfo是否正确配置');
      }
      var bucketSuffix = ['dev', 'test', 'pre', 'prod'].find(function (v) {
        return location.host.includes(v);
      }) || '';
      var url = "https://".concat(bucketSuffix, "web.zhixuehuijiao.cn/sub-help-center-svc/application?alias=").concat(alias, "&token=").concat(access_token, "&name=").concat(props.name);
      return url;
    };
    watch(function () {
      return props.alias;
    }, function (val) {
      if (val) {
        url.value = buildUrl(val);
      }
    }, {
      immediate: true,
      deep: true
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("iframe", {
        src: url.value,
        sandbox: "allow-scripts allow-same-origin allow-forms allow-downloads"
      }, null, 8, _hoisted_2)]);
    };
  }
};